angular.module('CarsSaraBo').directive('reviewDirective', ['ReviewsService','$translate', 'BookingService','$routeParams',
    function (reviewsService, $translate, bookingService, $routeParams) {

        return {
            scope: {
                review: '=',
                showDetail: '&',
                fenixOid: '=',
                showResponseBox: '=',
                errorSendingResponse: '=',
                responseAnalyzing: '=',
                response: '=',
                sendingResponse: '=',
                invalidTextResponse: '=',
                showLess: '='
            },

            link: function (scope) {
                const MAX_LENGTH_TEXT_RESPONSE = 150;

                scope.fenixOid;
                scope.showResponseBox = false;
                scope.sendingResponse = false;
                scope.showLess = true;

                scope.getEvaluationClass = function(param) {
                    return reviewsService.getEvaluationClass(param);
                }

                scope.getScoreClass = function(param) {
                    return reviewsService.getScoreClass(param);
                }

                scope.formatDate = function (date) {//format valid for string is ISO Date (2019-05-03 YYYY-MM-DD)
                    var formattedDate = '';
                    if(date){
                        var newDate = new Date(date);
                        var month = newDate.getUTCMonth() + 1;
                        month = (month < 10)?'0' + month:month;

                        formattedDate = (newDate.getUTCDate()) + ' ' + $translate.instant('common.month.' + month) + ' ' + newDate.getUTCFullYear();
                    }
                    return formattedDate;
                }

                scope.rounded = function(num){
                    return Math.round(num * 10) / 10;
                }

                scope.getBookingOid = function(fenixOid){
                    scope.fenixOid = fenixOid;
                    scope.showDetail({fenixOid: scope.fenixOid});
                }

                scope.switchShowResponseBox = function(){
                    scope.showResponseBox =  !scope.showResponseBox;
                }

                scope.sendReviewResponse = function(){

                    if(scope.isValidResponseText()){
                        scope.$parent.sendResponseGA();
                        scope.sendingResponse = true;
                        scope.invalidTextResponse = false;
                        var btnSendResponse = document.getElementById("btnSendResponse_" + scope.review.reviewOid);

                        reviewsService.sendReviewResponse($routeParams.companyOid, scope.response, false, scope.review.reviewOid).then(function(response){
                            scope.review.response = response;
                            scope.showResponseBox = false;
                            scope.sendingResponse = false;
                            btnSendResponse.classList.remove("-loading");
                            btnSendResponse.removeAttribute("disabled");
                        },function (error) {
                            scope.$parent.clearToastError();
                            scope.errorSendingResponse = true;
                            scope.sendingResponse = false;
                            btnSendResponse.classList.remove("-loading");
                            btnSendResponse.removeAttribute("disabled");
                        });
                    }else{
                        scope.invalidTextResponse = true;
                    }
                }

                scope.showButtonResponse = function(){
                    return !scope.showResponseBox && !scope.review.response;
                }

                scope.isValidResponseText = function () {
                    scope.errorSendingResponse = false;
                    scope.invalidTextResponse = false;
                    var textResponse = document.getElementById("txtTextResponse_" + scope.review.reviewOid);
                    var result = false;

                    if(textResponse && textResponse.value.length > 0){
                        removeClassCommentError(textResponse);
                        result = true;
                    }else{
                        scope.invalidTextResponse = true;
                        textResponse.className += " response-comment-error";
                    }
                    return result;
                }

                scope.cancelSendResponse = function () {
                    var textResponse = document.getElementById("txtTextResponse_" + scope.review.reviewOid);
                    textResponse.value = '';
                    scope.$parent.cancelSendResponseGA();
                    scope.errorSendingResponse = false;
                    scope.switchShowResponseBox();
                }

                function removeClassCommentError(textResponse){
                    textResponse.classList.remove("response-comment-error");
                }

                scope.clearTextResponse = function () {
                    var textResponse = document.getElementById("txtTextResponse_" + scope.review.reviewOid);
                    scope.errorSendingResponse = false;

                    if(textResponse){
                        scope.invalidTextResponse = false;
                        removeClassCommentError(textResponse);
                    }
                }

                scope.viewMoreLess = function(text){
                    var lblResponse = document.getElementById("lblTextResponse_" + scope.review.reviewOid);
                    var textToShow = text;

                    if(lblResponse && text){

                        if (scope.showLess && text.length > MAX_LENGTH_TEXT_RESPONSE) {
                            textToShow = text.substring(0, MAX_LENGTH_TEXT_RESPONSE) + ' ...';
                        }
                    }
                    return textToShow;
                }

                scope.switchViewMoresLess = function (){
                    var linkViewMoreLess = document.getElementById("linkViewMoreLess_" + scope.review.reviewOid);
                    var textToShow = (scope.showLess) ? 'common.VIEW_LESS' : 'common.VIEW_MORE';

                    linkViewMoreLess.text = $translate.instant(textToShow);
                    scope.showLess = !scope.showLess;
                }
            },

            templateUrl: 'assets/reviews/review-detail.html'
        };
    }
]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/directives/review_directive.js
// module id = 884
// module chunks = 3